<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  tabindex: {
    type: Number,
  },
  v: {
    type: Object,
    required: true,
  },
})

const emits = defineEmits(['update:modelValue', 'changed'])

onMounted(async () => {
  if (props.autofocus)
    document.getElementById(props.name).focus()
})

function getErrorMsg(err) {
  if (err) {
    if (err.$params.msg)
      return err.$params.msg
    if (err.$message)
      return err.$message
  }
}

const errors = computed(() => {
  return props.v.$errors.slice(0, 1)
})

watch(
  () => props.modelValue,
  (newVal, oldVal) => {
    if (newVal !== oldVal)
      emits('changed')
  },
)
</script>

<template>
  <div :data-for="name" class="cd-form__checkbox-container" :class="{ 'cd-form-error': errors.length > 0 }">
    <label :for="name" class="cd-mb-3">
      <input :id="name" :checked="modelValue" type="checkbox" :name="name" :tabindex="tabindex" @change="$emit('update:modelValue', $event.target.checked)">
      <span><slot /></span>
    </label>
    <FormError :message="getErrorMsg(errors[0])" />
  </div>
</template>
